import React from 'react';

const AuditTrail = () => (
    <div style={cardStyle}>
        <h2 style={{color: '#1a2234'}}>📜 Audit Trail / Activity Logs</h2>
        <p style={tagStyle}>Status: Under Development</p>
        <p>Har action ka record: Kisne, kab, aur kya tabdeeli ki.</p>
        <ul style={{listStyle: 'none', padding: 0, marginTop: '20px'}}>
            <li style={logItem}>Loading activity logs...</li>
        </ul>
    </div>
);

const cardStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' };
const tagStyle = { backgroundColor: '#fef3c7', color: '#92400e', padding: '5px 10px', borderRadius: '5px', display: 'inline-block', fontSize: '12px' };
const logItem = { padding: '10px', borderBottom: '1px solid #f1f5f9', color: '#94a3b8', fontStyle: 'italic' };

export default AuditTrail;